/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILxsInformationHeaderData } from './lxs-information-header.data';
import { ILxsInformationHeaderProps } from './lxs-information-header.props.autogenerated';

export interface ILxsInformationHeaderViewProps extends ILxsInformationHeaderProps<ILxsInformationHeaderData> {}

/**
 *
 * LxsInformationHeader component
 * @extends {React.PureComponent<ILxsInformationHeaderProps<ILxsInformationHeaderData>>}
 */
class LxsInformationHeader extends React.PureComponent<ILxsInformationHeaderProps<ILxsInformationHeaderData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LxsInformationHeader;
